module.exports = __webpack_public_path__ + "static/logo-180f17efeb69655fae4956a9238c1fa1.svg";